import PlayerService from '../services/player'
import router from '@router';

const mutations = {
  CREATE_PLAYER_REQUEST(state) {
    state.isCreatingPlayer = true
  },
  CREATE_PLAYER_SUCCESS(state) {
    state.isCreatingPlayer = false
  },
  CREATE_PLAYER_FAILURE(state) {
    state.isCreatingPlayer = false
  },
  FETCH_PLAYERS_REQUEST(state) {
    state.isFetchingPlayers = true
  },
  FETCH_PLAYERS_SUCCESS(state, payload) {
    state.isFetchingPlayers = false
    state.players = payload
  },
  FETCH_PLAYERS_FAILURE(state) {
    state.isFetchingPlayers = false
  },
  FETCH_PLAYER_REQUEST(state) {
    state.isFetchingPlayer = true
  },
  FETCH_PLAYER_SUCCESS(state, payload) {
    state.isFetchingPlayer = false
    state.playerDetail = { ...state.playerDetail, ...payload}
  },
  FETCH_PLAYER_FAILURE(state) {
    state.isFetchingPlayer = false
  },
  UPDATE_PLAYER_REQUEST(state) {
    state.isUpdatingPlayer = true
    state.isUpdatingPlayerSuccess = false
  },
  UPDATE_PLAYER_SUCCESS(state) {
    state.isUpdatingPlayer = false
    state.isUpdatingPlayerSuccess = true
  },
  UPDATE_PLAYER_FAILURE(state) {
    state.isUpdatingPlayer = false
  },
  UNLOCK_PLAYER_PROMOTION_REQUEST(state) {
    state.isUnlockingPlayerPromotion = true
    state.isUnlockingPlayerPromotionSuccess = false
  },
  UNLOCK_PLAYER_PROMOTION_SUCCESS(state) {
    state.isUnlockingPlayerPromotion = false
    state.isUnlockingPlayerPromotionSuccess = true
  },
  UNLOCK_PLAYER_PROMOTION_FAILURE(state) {
    state.isUnlockingPlayerPromotion = false
  },
  BAN_PLAYER_REQUEST(state) {
    state.isBanningPlayer = true
  },
  BAN_PLAYER_SUCCESS(state) {
    state.isBanningPlayer = false
  },
  BAN_PLAYER_FAILURE(state) {
    state.isBanningPlayer = false
  },
  DELETE_PLAYER_REQUEST(state) {
    state.isDeletingPlayer = true
  },
  DELETE_PLAYER_SUCCESS(state) {
    state.isDeletingPlayer = false
  },
  DELETE_PLAYER_FAILURE(state) {
    state.isDeletingPlayer = false
  },
  DEPOSIT_PLAYER_CREDIT_REQUEST(state) {
    state.isDepositingPlayerCredit = true
  },
  DEPOSIT_PLAYER_CREDIT_SUCCESS(state) {
    state.isDepositingPlayerCredit = false
  },
  DEPOSIT_PLAYER_CREDIT_FAILURE(state) {
    state.isDepositingPlayerCredit = false
  },
  WITHDRAW_PLAYER_CREDIT_REQUEST(state) {
    state.isWithdrawingPlayerCredit = true
  },
  WITHDRAW_PLAYER_CREDIT_SUCCESS(state) {
    state.isWithdrawingPlayerCredit = false
  },
  WITHDRAW_PLAYER_CREDIT_FAILURE(state) {
    state.isWithdrawingPlayerCredit = false
  },
  ADD_FREE_CREDIT_PLAYER_REQUEST(state) {
    state.isAddingPlayerFreeCredit = true
  },
  ADD_FREE_CREDIT_PLAYER_SUCCESS(state) {
    state.isAddingPlayerFreeCredit = false
  },
  ADD_FREE_CREDIT_PLAYER_FAILURE(state) {
    state.isAddingPlayerFreeCredit = false
  },
  FETCH_PLAYER_AF_REQUEST(state) {
    state.isFetchingPlayerAf = true
  },
  FETCH_PLAYER_AF_SUCCESS(state, payload) {
    state.isFetchingPlayerAf = false
    state.playerAfLogs = payload
  },
  FETCH_PLAYER_AF_FAILURE(state) {
    state.isFetchingPlayerAf = false
  },
  FETCH_PLAYER_CASHBACK_REQUEST(state) {
    state.isFetchingPlayerCashback = true
  },
  FETCH_PLAYER_CASHBACK_SUCCESS(state, payload) {
    state.isFetchingPlayerCashback = false
    state.playerCashbackLogs = payload
  },
  FETCH_PLAYER_CASHBACK_FAILURE(state) {
    state.isFetchingPlayerCashback = false
  },
  FETCH_PLAYER_PROMOTION_REQUEST(state) {
    state.isFetchingPlayerPromotion = true
  },
  FETCH_PLAYER_PROMOTION_SUCCESS(state, payload) {
    state.isFetchingPlayerPromotion = false
    state.playerPromotionLogs = payload
  },
  FETCH_PLAYER_PROMOTION_FAILURE(state) {
    state.isFetchingPlayerPromotion = false
  },
  FETCH_PLAYER_AF_MEMBER_REQUEST(state) {
    state.isFetchingPlayerAfMembers = true
  },
  FETCH_PLAYER_AF_MEMBER_SUCCESS(state, payload) {
    state.isFetchingPlayerAfMembers = false
    state.playerAfMembers = payload
  },
  FETCH_PLAYER_AF_MEMBER_FAILURE(state) {
    state.isFetchingPlayerAfMembers = false
  },
  FETCH_LATEST_PROMOTION_REQUEST(state) {
    state.isFetchingLatestPromotion = true
  },
  FETCH_LATEST_PROMOTION_SUCCESS(state, payload) {
    state.isFetchingLatestPromotion = false
    state.latestPromotion = payload
  },
  FETCH_LATEST_PROMOTION_FAILURE(state) {
    state.isFetchingLatestPromotion = false
  },
  FETCH_RESTORE_PLAYER_TURN_REQUEST(state) {
    state.isFetchingRestorePlayerTurn = true
  },
  FETCH_RESTORE_PLAYER_TURN_SUCCESS(state) {
    state.isFetchingRestorePlayerTurn = false
  },
  FETCH_RESTORE_PLAYER_TURN_FAILURE(state) {
    state.isFetchingRestorePlayerTurn = false
  }
}
const actions = {
  async createPlayer({ commit, dispatch }, data) {
    try {
      commit('CREATE_PLAYER_REQUEST')
      const response = await PlayerService.createPlayer(data)
      commit('CREATE_PLAYER_SUCCESS', response)
      dispatch('notifySuccess', 'created')
      router.push('/players/detail/' + response.id)
    } catch (e) {
      dispatch('notifyError', e)
      commit('CREATE_PLAYER_FAILURE', e.message)
    }
  },
  async fetchPlayers(
    { commit, dispatch },
    { limit = '', page = '', search = '', agentId = '', masterId = '', startDate = null, endDate = null, isDeposited = null }
  ) {
    try {
      commit('FETCH_PLAYERS_REQUEST')
      const response = await PlayerService.getPlayers({
        limit, page, search, masterId, agentId, startDate, endDate, isDeposited
      })
      commit('FETCH_PLAYERS_SUCCESS', response)
    } catch (e) {
      dispatch('notifyError', e)
      commit('FETCH_PLAYERS_FAILURE', e.message)
    }
  },
  async fetchPlayer({ commit, dispatch }, id) {
    try {
      commit('FETCH_PLAYER_REQUEST')
      const response = await PlayerService.fetchPlayerById(id)
      commit('FETCH_PLAYER_SUCCESS', response)
    } catch (e) {
      dispatch('notifyError', e)
      commit('FETCH_PLAYER_FAILURE', e.message)
    }
  },
  async updatePlayer({ commit, dispatch }, { playerId, data }) {
    try {
      commit('UPDATE_PLAYER_REQUEST')
      await PlayerService.updatePlayer(playerId, data)
      commit('UPDATE_PLAYER_SUCCESS')
      dispatch('notifySuccess', 'updated')
    } catch (e) {
      dispatch('notifyError', e)
      commit('UPDATE_PLAYER_FAILURE', e.message)
    }
  },
  async unlockPlayerPromotion({ commit, dispatch }, { playerId, search, removePromotion }) {
    try {
      commit('UNLOCK_PLAYER_PROMOTION_REQUEST')
      await PlayerService.unlockPlayerPromotion(playerId, removePromotion)
      dispatch('fetchPlayers', { search })
      commit('UNLOCK_PLAYER_PROMOTION_SUCCESS')
      dispatch('notifySuccess')
    } catch (e) {
      dispatch('notifyError', e)
      commit('UNLOCK_PLAYER_PROMOTION_FAILURE', e.message)
    }
  },
  async exchangePlayerWallet({  dispatch }, { playerId, search }) {
    try {
      // commit('UNLOCK_PLAYER_PROMOTION_REQUEST')
      await PlayerService.exchangePlayerWallet(playerId)
      dispatch('fetchPlayers', { search })
      // commit('UNLOCK_PLAYER_PROMOTION_SUCCESS')
      dispatch('notifySuccess')
    } catch (e) {
      dispatch('notifyError', e)
      // commit('UNLOCK_PLAYER_PROMOTION_FAILURE', e.message)
    }
  },
  async exportPlayers({ dispatch }, params) {
    try {
      await PlayerService.exportPlayers(params)
      dispatch('notifySuccess')
    } catch (e) {
      dispatch('notifyError', e)
    }
  },
  async banPlayer({ commit, dispatch }, userId) {
    try {
      commit('BAN_PLAYER_REQUEST')
      await PlayerService.banPlayer(userId)
      commit('BAN_PLAYER_SUCCESS')
      dispatch('notifySuccess')
    } catch (e) {
      dispatch('notifyError', e)
      commit('BAN_PLAYER_FAILURE', e.message)
    }
  },
  async setUserBetLimit({ dispatch }, data) {
    try {
      await PlayerService.setUserBetLimit(data.id, data.payload)
      dispatch('notifySuccess')
    } catch (e) {
      dispatch('notifyError', e)
    }
  },
  async deletePlayer({ commit, dispatch }, userId) {
    try {
      commit('DELETE_PLAYER_REQUEST')
      await PlayerService.deletePlayer(userId)
      commit('DELETE_PLAYER_SUCCESS')
      dispatch('notifySuccess')
    } catch (e) {
      dispatch('notifyError', e)
      commit('DELETE_PLAYER_FAILURE', e.message)
    }
  },
  async resetPasswordPlayer({ commit, dispatch }, data) {
    try {
      commit('RESET_PASSWORD_PLAYER_REQUEST')
      await PlayerService.resetPassword(data.id, data)
      commit('RESET_PASSWORD_PLAYER_SUCCESS')
      dispatch('notifySuccess', 'updated')
    } catch (e) {
      dispatch('notifyError', e)
      commit('RESET_PASSWORD_PLAYER_FAILURE', e.message)
    }
  },
  async depositPlayerCredit({ commit, dispatch }, { playerId, data, search }) {
    try {
      commit('DEPOSIT_PLAYER_CREDIT_REQUEST')
      await PlayerService.depositPlayerCredit(playerId, data)
      commit('DEPOSIT_PLAYER_CREDIT_SUCCESS')
      dispatch('fetchPlayers', { search })
      dispatch('notifySuccess')
    } catch (e) {
      dispatch('notifyError', e)
      commit('DEPOSIT_PLAYER_CREDIT_FAILURE', e.message)
    }
  },
  async withdrawPlayerCredit({ commit, dispatch }, { playerId, data, search }) {
    try {
      commit('WITHDRAW_PLAYER_CREDIT_REQUEST')
      await PlayerService.withdrawPlayerCredit(playerId, data)
      commit('WITHDRAW_PLAYER_CREDIT_SUCCESS')
      dispatch('fetchPlayers', { search })
      dispatch('notifySuccess')
    } catch (e) {
      dispatch('notifyError', e)
      commit('WITHDRAW_PLAYER_CREDIT_FAILURE', e.message)
    }
  },
  async addFreeCreditPlayer({ commit, dispatch }, { playerId, search }) {
    if(state.isAddingPlayerFreeCredit) return
    try {
      commit('ADD_FREE_CREDIT_PLAYER_REQUEST')
      await PlayerService.addFreeCreditPlayer(playerId)
      commit('ADD_FREE_CREDIT_PLAYER_SUCCESS')
      dispatch('fetchPlayers', { search })
      dispatch('notifySuccess')
    } catch (e) {
      dispatch('notifyError', e)
      commit('ADD_FREE_CREDIT_PLAYER_FAILURE', e.message)
    }
  },
  async fetchPlayerAfLogs({ commit, dispatch }, playerId) {
    try {
      commit('FETCH_PLAYER_AF_REQUEST')
      const result = await PlayerService.fetchPlayerAf(playerId)
      commit('FETCH_PLAYER_AF_SUCCESS', result)
    } catch (e) {
      dispatch('notifyError', e)
      commit('FETCH_PLAYER_AF_FAILURE', e.message)
    }
  },
  async fetchPlayerCashbackLogs({ commit, dispatch }, playerId) {
    try {
      commit('FETCH_PLAYER_CASHBACK_REQUEST')
      const result = await PlayerService.fetchPlayerCashback(playerId)
      commit('FETCH_PLAYER_CASHBACK_SUCCESS', result)
    } catch (e) {
      dispatch('notifyError', e)
      commit('FETCH_PLAYER_CASHBACK_FAILURE', e.message)
    }
  },
  async fetchPlayerPromotionLogs({ commit, dispatch }, playerId) {
    try {
      commit('FETCH_PLAYER_PROMOTION_REQUEST')
      const result = await PlayerService.fetchPlayerPromotion(playerId)
      commit('FETCH_PLAYER_PROMOTION_SUCCESS', result)
    } catch (e) {
      dispatch('notifyError', e)
      commit('FETCH_PLAYER_PROMOTION_FAILURE', e.message)
    }
  },
  async fetchPlayerAfMembers({ commit, dispatch }, {playerId, currentPage, limit, search}) {
    try {
      commit('FETCH_PLAYER_AF_MEMBER_REQUEST')
      const result = await PlayerService.fetchPlayerAfMembers(playerId, currentPage, limit, search)
      commit('FETCH_PLAYER_AF_MEMBER_SUCCESS', result)
    } catch (e) {
      dispatch('notifyError', e)
      commit('FETCH_PLAYER_AF_MEMBER_FAILURE', e.message)
    }
  },
  async fetchLatestPromotion({ commit }, userId) {
    try {
      commit('FETCH_LATEST_PROMOTION_REQUEST')
      const result = await PlayerService.fetchLatestPromotion(userId)
      commit('FETCH_LATEST_PROMOTION_SUCCESS', result)
    } catch (e) {
      commit('FETCH_LATEST_PROMOTION_FAILURE', e.message)
    }
  },
  async restorePlayerTurn({ commit, dispatch }, userId) {
    try {
      commit('FETCH_RESTORE_PLAYER_TURN_REQUEST')
      await PlayerService.restorePlayerTurn(userId)
      dispatch('notifySuccess')
      commit('FETCH_RESTORE_PLAYER_TURN_SUCCESS')
    } catch (e) {
      dispatch('notifyError', e)
      commit('FETCH_RESTORE_PLAYER_TURN_FAILURE')
    }
  }
}
const getters = {
  players: (state) => state.players,
  playerDetail: (state) => state.playerDetail,
  playerAfLogs: (state) => state.playerAfLogs,
  playerCashbackLogs: (state) => state.playerCashbackLogs,
  playerPromotionLogs: (state) => state.playerPromotionLogs,
  playerAfMembers: (state) => state.playerAfMembers,
}
const state = {
  players: { items: [], meta: { currentPage: 1, itemCount: 0, itemsPerPage: 0, totalItems: 0,totalPages: 0 }},
  isFetchingPlayers: false,
  isCreatingPlayer: false,

  playerDetail: {
    affiliateByUsername: '',
    createdAt: '',
    lastLoggedInAt: '',
    bankAccount: {
      bankAccountNumber: '',
      bankCode: '',
    },
    profile: {
      username: '',
      phoneNumber: '',
      affiliateLink: '',
      codeName: '',
      firstname: '',
      lastname: '',
      note: '',
    },
    summary: {
      affiliateCredit: 0,
      affiliateTotalCredit: 0,
      affiliatePromotionCredit: 0,
      affiliatePromotionTotalCredit: 0,
      affiliateMemberCount: 0,
      cashbackCredit: 0,
      cashbackTotalCredit: 0,
      credit: 0,
      holdCredit: 0,
      totalBonus: 0,
      totalDeposit: 0,
      totalWithdraw: 0,
      totalSlotBet: 0,
      totalFishingBet: 0,
      totalCasinoBet: 0
    },
  },
  isFetchingPlayer: false,

  isUpdatingPlayer: false,
  isUpdatingPlayerSuccess: false,

  isUnlockingPlayerPromotion: false,
  isUnlockingPlayerPromotionSuccess: false,
  
  isBanningPlayer: false,

  isDeletingPlayer: false,

  isDepositingPlayerCredit: false,
  isWithdrawingPlayerCredit: false,
  isAddingPlayerFreeCredit: false,

  isFetchingPlayerAf: false,
  playerAfLogs: [],

  isFetchingPlayerCashback: false,
  playerCashbackLogs: [],

  isFetchingPlayerPromotion: false,
  playerPromotionLogs: [],

  isFetchingPlayerAfMembers: false,
  playerAfMembers: [],

  isFetchingLatestPromotion: false,
  latestPromotion: null,

  isFetchingRestorePlayerTurn: false
}
export default {
  state,
  mutations,
  actions,
  getters,
}
